import styled from "@emotion/styled";
import Button from "metabase/core/components/Button";

export const IconButton = styled(Button)`
  margin-left: 0.5rem;
`;
